import React, { type FC, type PropsWithChildren } from "react";
import { ReadinessProvider } from "@domain/context/DataReadyness";
import { AppSettingsProvider } from "@domain/context/AppSettingsProvider";
import { CalendarEventsProvider } from "@domain/context/CalendarEventsContext";
import { CalendarItemStateProvider } from "@domain/context/CalendarItemStateContext";
import { CompanyProvider } from "@domain/context/CompanyContext";
import { ContactsProvider } from "@domain/context/ContactsContext";
import { DmsDataProvider } from "@domain/context/DmsDataProvider";
import { EntitiesProvider } from "@domain/context/accountingData/KontoEntitiesProvider";
import { PaymentsProvider } from "@domain/context/accountingData/PaymentsProvider";
import { RecordsControlProvider } from "@domain/context/accountingData/RecordsControlCtx";
import { RecordsProvider } from "@domain/context/accountingData/RecordsCtx";
import { SaldoSourcesProvider } from "@domain/context/accountingData/SaldoSourcesProvider";
import { UserProvider } from "@domain/context/UserProvider";
import { UserSettingsProvider } from "@domain/context/UserSettingsProvider";
import { DatevContextProvider } from "@domain/context/DatevContext";
import { BanksContextProvider } from "@domain/context/BanksContext";
import { CashRegisterContextProvider } from "@domain/context/CashRegisterContext";

export const ContextProvider: FC<PropsWithChildren> = (props) => {
    return (
        <AppSettingsProvider>
            <UserProvider>
                <DatevContextProvider>
                    <CompanyProvider>
                        <UserSettingsProvider>
                            <EntitiesProvider>
                                <RecordsProvider>
                                    <SaldoSourcesProvider>
                                        <RecordsControlProvider>
                                            <PaymentsProvider>
                                                <ContactsProvider>
                                                    <CalendarEventsProvider>
                                                        <CalendarItemStateProvider>
                                                            <ReadinessProvider>
                                                                <BanksContextProvider>
                                                                    <CashRegisterContextProvider>
                                                                        <DmsDataProvider>
                                                                            {props.children}
                                                                        </DmsDataProvider>
                                                                    </CashRegisterContextProvider>
                                                                </BanksContextProvider>
                                                            </ReadinessProvider>
                                                        </CalendarItemStateProvider>
                                                    </CalendarEventsProvider>
                                                </ContactsProvider>
                                            </PaymentsProvider>
                                        </RecordsControlProvider>
                                    </SaldoSourcesProvider>
                                </RecordsProvider>
                            </EntitiesProvider>
                        </UserSettingsProvider>
                    </CompanyProvider>
                </DatevContextProvider>
            </UserProvider>
        </AppSettingsProvider>
    );
};
